import { type StoreActionApi } from 'react-sweet-state';

import { fg } from '@atlaskit/platform-feature-flags';

import {
	type ExtraErrorAttributes,
	type InnerContainerProps,
	type State,
} from '../common/utils/types';

export const reporterAction =
	({
		id,
		error,
		attributes,
		teamName,
	}: {
		attributes?: ExtraErrorAttributes;
		error: unknown;
		id: string;
		teamName?: string;
	}) =>
	({}: StoreActionApi<State>, { reporter }: InnerContainerProps) => {
		if (reporter) {
			if (fg('eoc_fix_error_reporting')) {
				reporter({ id, error, attributes, teamName });
			} else {
				reporter({ id, error, attributes });
			}
			return;
		}
	};

export const getHorizontalNav =
	() =>
	({}: StoreActionApi<State>, { config }: InnerContainerProps) => {
		return config?.isNewNavigation || false;
	};
